import React from "react";
import { Container, Row, Col, } from "react-bootstrap";
import icon from '../assets/img/check.svg';
import LogoSlider from '../components/LogoSlider';

function Service() {
    return (
      <div className="service-page">
      <section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/interior.jpg')} alt="Interior and Exterior 
Painting" className='img-fluid' />
            </div>
          </Col>
          <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Interior and Exterior Painting</h2>
            
            <p>
            Transform your space with our professional painting services.  
            </p>
            <p>
            <b>Interior Painting:</b> We create vibrant, inviting, and durable interiors with a wide selection of colors and finishes. Our team uses top-quality materials and meticulous techniques to ensure smooth and long-lasting results.
            </p>
            <p><b>Exterior Painting:</b> Enhance your property’s curb appeal with expert exterior painting that withstands harsh weather conditions. We prepare the surfaces thoroughly to achieve a flawless finish.</p>
            
          
            </div>
          </Col>
        </Row>
      </Container>
      </section>

      <section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">General Contracting
            </h2>
            
            <p>
            Simplify your construction or remodeling project with our comprehensive general contracting services.</p>

            <p>From project planning and design to execution, we manage every aspect to ensure seamless progress.</p>

<p>Our team coordinates with trusted subcontractors and suppliers to deliver projects on time and within budget.</p>

<p>We adhere to strict quality and safety standards, ensuring your project is completed with excellence.</p>
            
          
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/concret.jpg')} alt="Concrete Work" className='img-fluid' />

            </div>
          </Col>
        </Row>
      </Container>
</section>

<section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/remolding.jpg')} alt="Interior and Exterior Remodeling" className='img-fluid' />
                    </div>
          </Col>
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Remodeling Services</h2>
            
            <p>Revitalize your home or commercial space with our custom remodeling solutions.</p>

<p><b>Kitchen Remodeling:</b> Upgrade your kitchen with modern designs, functional layouts, and premium finishes. We specialize in cabinetry, countertops, flooring, and lighting.</p>

<p><b>Bathroom Remodeling:</b> Create a spa-like retreat with our bathroom remodeling services, including custom showers, vanities, and tile work.</p>

<p><b>Basement Remodeling:</b> Turn your basement into a functional living area, whether it’s a home office, gym, or entertainment room.</p>
          
            </div>
          </Col>
          
        </Row>
      </Container>
</section>

<section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Siding Installation and Repair
            </h2>
            
            <p>Protect and beautify your property with our siding solutions.</p>

<p><b>Installation:</b> We offer a variety of siding materials, including vinyl, fiber cement, and wood, tailored to suit your style and budget.</p>

<p><b>Repair:</b> Our team addresses damages such as cracks, warping, and discoloration, restoring the integrity and appearance of your siding.</p>
          
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/siding.jpg')} alt="siding" className='img-fluid' />

            </div>
          </Col>
        </Row>
      </Container>
</section>

<section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/porches.jpg')} alt="Porches" className='img-fluid' />
            </div>
          </Col>
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Roofing Services
            </h2>
            <p>Ensure your property’s safety and durability with our expert roofing services.</p>

<p><b>Roof Installation:</b> We install high-quality roofs using materials such as asphalt shingles, metal, and flat roofing systems.</p>

<p><b>Roof Repair:</b> From leaks to storm damage, our team quickly and efficiently addresses all types of roofing issues.</p>

<p><b>Roof Maintenance:</b> Regular inspections and maintenance extend the lifespan of your roof, saving you money in the long run.</p>
          
            </div>
          </Col>
          
        </Row>
      </Container>
</section>

<section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Carpentry and Custom Woodwork</h2>
            
            <p>Add a touch of elegance and functionality to your space with our bespoke carpentry services.</p>

<p><b>Custom Furniture:</b> We design and build furniture tailored to your needs and style, including tables, shelves, and cabinets.</p>

<p><b>Trim and Moldings:</b> Enhance the beauty of your interiors with expertly crafted crown moldings, baseboards, and wainscoting.</p>

<p><b>Built-in Units:</b> Optimize your space with custom-built closets, entertainment centers, and storage solutions.</p>
          
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/molding.jpg')} alt="Molding and Framing" className='img-fluid' />
            </div>
          </Col>
        </Row>
      </Container>
</section>

<section className="welcome-message section-padding">
      <Container>
        <Row className="align-items-center ">
        <Col lg={3} sm={12}>
            <div className="welcome-img">
            <img src={require('../assets/img/services/siding.jpg')} alt="siding" className='img-fluid' />
            </div>
        </Col>
        <Col lg={9} sm={12}>
          <div className="d-flex flex-column infor-di">
            
            <h2 className="title">Additional Services</h2>
            
            <p>We go beyond the ordinary to cater to your specific needs.</p>

<p><b>Deck and Patio Construction:</b> Extend your living space with beautifully designed outdoor areas perfect for relaxation and entertainment.</p>

<p><b>Drywall Installation and Repair:</b> Ensure smooth, flawless walls and ceilings with our drywall services.</p>

<p><b>Flooring Installation:</b> Choose from hardwood, laminate, tile, or vinyl flooring expertly installed to suit your preferences.</p>

          
            </div>
          </Col>
          
        </Row>
      </Container>
</section>


<section className="logo-slider">
        <Container>
            <Row>
                <Col lg={12} sm={12}>
                  <LogoSlider />
                </Col>
            </Row>
        </Container>
     </section>
</div>
    );
}

export default Service;
